import { render, staticRenderFns } from "./PromotionEditRange.vue?vue&type=template&id=50b6ea1c&"
import script from "./PromotionEditRange.vue?vue&type=script&lang=js&"
export * from "./PromotionEditRange.vue?vue&type=script&lang=js&"
import style0 from "./PromotionEditRange.vue?vue&type=style&index=0&id=50b6ea1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports